import { IOptionPickerBusinessLogic, OptionPicker, createOptionPicker } from '@vfde-brix/ws10/option-picker';
import { HtmlId } from '../enums/elementId';
import { mountComponent } from '../util/mount';
import { getTariffItem } from '../util/components/optionPickerHelper';
import { addDisplayMetacodeToTariffPicker } from '../util/displayMetacodes';
import { JarvisProduct } from '@vfde-sails/avc-core';

export const mountOptionPicker = (wrapperId: HtmlId, onChange: (value: string) => {}) => {
    const props: IOptionPickerBusinessLogic = {
        onChange: ({ target }) => {
            if (target && 'value' in target) {
                onChange(target.value as string);
            }
        },
    };

    return mountComponent(wrapperId, createOptionPicker, props);
};

export const updateTariffOptionPicker = (
    isContentEnabled: boolean,
    optionTab?: OptionPicker,
    tariffs: JarvisProduct[] = [],
    enabledIds?: string[],
    selectedId?: string,
) => {
    if (!optionTab) {
        return;
    }

    const items = tariffs.map(tariff => {
        const isEnabled = !enabledIds || enabledIds.includes(tariff.id);

        return getTariffItem(tariff, isEnabled && isContentEnabled, selectedId);
    });

    optionTab.update({ items });
    addDisplayMetacodeToTariffPicker();
};
